// src/constants/roomTypes.js
const ROOM_TYPES = {
  SINGLE: {
    name: 'Deluxe Single Queen Bed Room',
    description: 'A cozy queen size bed room perfect for solo or couple travelers.',
     images: [
      '/images/single/image1.jpg',
      '/images/single/image2.jpg',
      '/images/single/image3.jpg',
       '/images/single/image4.jpg',
      '/images/single/image5.jpg',
      '/images/single/image6.jpg',
       '/images/single/image7.jpg',
      '/images/single/image8.jpg',
      '/images/single/image9.jpg',
        '/images/single/image10.jpg',
      '/images/single/image11.jpg',
      '/images/single/image12.jpg'

    ]
  },
  DOUBLE: {
    name: 'Deluxe Two Queen Beds Room',
    description: 'A spacious room ideal for families, with two queen size beds, comfortably accommodating two adults and two children.',
    images: [
     '/images/double/image1.jpg',
      '/images/double/image2.jpg',
      '/images/double/image3.jpg',
       '/images/double/image4.jpg',
      '/images/double/image5.jpg',
      '/images/double/image6.jpg',
       '/images/double/image7.jpg',
      '/images/double/image8.jpg',
            '/images/double/image9.jpg'


    ]
  }, COTTAGE: {
  name: 'Two Room Cottage',
  description: `Cottage with 
2 bedrooms with 3 queen beds and one double bed, full washroom, living room, office space, enclosed porch, outdoor seating, and BBQ — perfect for families or group`,
  images: [
    '/images/cottage/image5.jpg',
    '/images/cottage/image6.jpg',
    '/images/cottage/image7.jpg',
    '/images/cottage/image8.jpg',
    '/images/cottage/image9.jpg',
    '/images/cottage/image10.jpg',
    '/images/cottage/image11.jpg',
    '/images/cottage/image12.jpg',
    '/images/cottage/image13.jpg',
    '/images/cottage/image14.jpg',
    '/images/cottage/image15.jpg',
    '/images/cottage/image16.jpg',
    '/images/cottage/image17.jpg',
    '/images/cottage/image18.jpg',
    '/images/cottage/image19.jpg',
    '/images/cottage/image20.jpg',
    '/images/cottage/image21.jpg',
    '/images/cottage/image22.jpg',
  ]
}
,
};

export default ROOM_TYPES;
